import { memo } from "react";
import { Div, useTheme, type DivProps } from "react-better-html";

type DecorationCardProps = DivProps & {};

function DecorationCard({ ...props }: DecorationCardProps) {
   const theme = useTheme();

   return (
      <Div.box
         border="none"
         boxShadow={theme.styles.boxShadow2}
         padding={theme.styles.space}
         paddingBottom={theme.styles.gap + theme.styles.gap / 2}
         {...props}
      ></Div.box>
   );
}

export default memo(DecorationCard);
